import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { LanguageProvider } from './contexts/LanguageContext';
import LanguageSwitcher from './components/LanguageSwitcher';

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter basename={__BASE_PATH__}>
        <LanguageSwitcher />
        <AppRoutes />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
